import Container from '@mui/material/Container'
import { CreateCampaignHeader } from '~/features/campaign_create/Header'
import { CreateCampaignContext } from '~/contexts/CreateCampaignContext'
import { FC, useContext } from 'react'
import { NavigationButtons } from '../NavigationButtons'
import { useCampaignPageStepForm } from '../useCampaignPageStepForm'
import { FormProvider } from 'react-hook-form'
import { z } from 'zod'
import { Gross, grossSchema, validateGross } from '../../campaign_input/Gross'

export const GrossContents: FC = () => {
  const { campaign } = useContext(CreateCampaignContext)
  const { onSubmit, onBack, useFormMethods } = useCampaignPageStepForm<
    z.input<typeof grossSchema>,
    z.output<typeof grossSchema>
  >({
    defaultValues: {
      basicGross:
        typeof campaign.basicGross === 'number' && campaign.basicGross < 1000 && campaign.sponsorServicePriceIntax === 0
          ? 1000
          : campaign.basicGross,
      campaignRequirementOptionSpecifiedPrText: campaign.campaignRequirementOptionSpecifiedPrText,
      campaignRequirementOptions: campaign.campaignRequirementOptions,
      campaignRequirementCompositionOptions: campaign.campaignRequirementCompositionOptions,
      sponsorServicePriceIntax: campaign.sponsorServicePriceIntax,
      gross: campaign.gross,
    },
    schema: grossSchema.superRefine(validateGross),
  })

  return (
    <form onSubmit={onSubmit}>
      <FormProvider {...useFormMethods}>
        <CreateCampaignHeader title="報酬・オプションに関する情報について教えてください" onBack={onBack} />
        <Container sx={{ display: 'flex', flexDirection: 'column' }} maxWidth="md">
          <Gross />
          <NavigationButtons />
        </Container>
      </FormProvider>
    </form>
  )
}
